<template>
  <div class="text-lg">
    <p  v-if="message" v-html="message"></p>
    <div v-else>
      <p>
        We are excited to join the Dig Pink Dig-A-Thon!
      </p>
      <p>
        To honor the 150,000 people living with stage Iv breast cancer in the U.S, we will DIVE, ROLL, HUSTLE, SPRAWL, and SACRIFICE for every dig while collecting pledges from our family, friends, and fans.
      </p>
      <p>
        For each dig we complete, we are supporting Side-Out’s cutting-edge clinical research, The Side-Out Protocol, which is adding precious time to the lives of those living with stage IV breast cancer.
      </p>
      <p>
        It’s our responsibility to take action and DO THE HARD STUFF to honor individuals who don’t have a choice to live their lives any other way.
      </p>
      <p>
        Support our pledge campaign and the stage IV community by making your pledge above!
      </p>
      <p>
        Thank you so much for helping us to make an impact!
      </p>

    </div>
  </div>
</template>

<script>
  export default {
    name: 'CampaignPledgeDrivePageMessage',

    props: {
      message: {
        type: String,
        required: false,
        default: '',
      },

    },

  }
</script>

<style scoped>

</style>
